import { useQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { fetchFactCatalogue } from '../api'

export function useFactCatalogueQuery(enabled = true) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: ['fact-catalogue', organization?.id],
    queryFn: async () => {
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return fetchFactCatalogue(token)
    },
    enabled: enabled && Boolean(organization?.id),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
